// import Vue
import Vue from 'vue'
import './gtm.js'

// import Vuetify
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'

import App from './App.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-30073001-1',
  router,
  linkers: ['gmelius.com']
})

// vue configuration
Vue.config.productionTip = false
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196f3',
        secondary: '#FC003A',
        accent: '#82B1FF',
        error: '#e63a36',
        info: '#2196F3',
        warning: '#FFC107'
      }
    }
  }
})
// inject Vuetify
Vue.use(Vuetify, {})

// set the local to 'en'
store.dispatch('setLocale', 'en')

// then init the Vue Instance
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
